import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Opens the generated invoice PDF in a new tab (download if popups are blocked)
export const openInvoicePdf = async (invoiceId, filename = 'factura.pdf') => {
  try {
    const resp = await axios.get(`${API}/admin/income-invoices/${invoiceId}/pdf`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
    const win = window.open(url, '_blank');
    if (win) win.opener = null;
    else {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } catch {
    toast.error('No se pudo generar el PDF');
  }
};

export const fetchBillingSettings = async () => (await axios.get(`${API}/admin/billing/settings`)).data;
export const fetchNextInvoiceNumber = async (date) => (await axios.get(`${API}/admin/billing/next-number`, { params: { date } })).data.number;
